import { useEffect, useRef } from "react";

// polls only while the tab is visible, and catches up once on re-show
export default function usePolling(callback, intervalMs, enabled = true) {
  const callbackRef = useRef(callback);
  useEffect(() => {
    callbackRef.current = callback;
  });

  useEffect(() => {
    if (!enabled) {
      return undefined;
    }
    let intervalId = null;
    let lastRun = Date.now();
    const run = () => {
      lastRun = Date.now();
      callbackRef.current();
    };
    const start = () => {
      if (intervalId === null) {
        intervalId = setInterval(run, intervalMs);
      }
    };
    const stop = () => {
      clearInterval(intervalId);
      intervalId = null;
    };
    const onVisibilityChange = () => {
      if (document.visibilityState === "hidden") {
        stop();
      } else {
        // a short switch away is not a missed cycle, so don't re-fetch on every re-show
        if (Date.now() - lastRun >= intervalMs) {
          run();
        }
        start();
      }
    };
    if (document.visibilityState !== "hidden") {
      start();
    }
    document.addEventListener("visibilitychange", onVisibilityChange);
    return () => {
      stop();
      document.removeEventListener("visibilitychange", onVisibilityChange);
    };
  }, [enabled, intervalMs]);
}
